import { RESOURCE_CATEGORIES } from "@/lib/resources-data"

export interface ResourceFilters {
    query: string
    category: string
    dailyOnly: boolean
}

export function filterResources(filters: ResourceFilters) {
    const query = filters.query.toLowerCase().trim()

    return RESOURCE_CATEGORIES.filter(
        (category) =>
            filters.category === "all" || category.id === filters.category
    )
        .map((category) => ({
            ...category,
            items: category.items.filter((item) => {
                if (filters.dailyOnly && item.badge !== "daily") return false
                return (
                    !query ||
                    item.title.toLowerCase().includes(query) ||
                    item.description.toLowerCase().includes(query) ||
                    category.title.toLowerCase().includes(query)
                )
            }),
        }))
        .filter((category) => category.items.length > 0)
}
